"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HodGetToKnowUsStep = void 0;
const BaseUserOnboardingStep_1 = require("../../../common/domain/BaseUserOnboardingStep");
const validator_1 = require("@leavy/validator");
const HodOnboardingStepId_1 = require("../HodOnboardingStepId");
const HodGetToKnowUsData_1 = require("./HodGetToKnowUsData");
class HodGetToKnowUsStep extends BaseUserOnboardingStep_1.BaseUserOnboardingStep {
    constructor() {
        super(...arguments);
        this.stepId = HodOnboardingStepId_1.HodOnboardingStepId.HOD_GET_TO_KNOW_US;
    }
    getDataConstructor() {
        return HodGetToKnowUsData_1.HodGetToKnowUsData;
    }
    getDefaultData() {
        return new HodGetToKnowUsData_1.HodGetToKnowUsData();
    }
}
__decorate([
    (0, validator_1.Type)(() => HodGetToKnowUsData_1.HodGetToKnowUsData),
    __metadata("design:type", HodGetToKnowUsData_1.HodGetToKnowUsData)
], HodGetToKnowUsStep.prototype, "data", void 0);
exports.HodGetToKnowUsStep = HodGetToKnowUsStep;
//# sourceMappingURL=HodGetToKnowUsStep.js.map